module.exports = __webpack_public_path__ + "static/img/playLogo.14bfd9d3.png";